import { pbiMockDataEnabledAtom } from "../../state/pbi.atoms";
import { CalculatorsState } from "../models/calculators.models";
import { initialCalculatorsRequest } from "./calculators.defaults";
import { atom } from "jotai";

// Keeps calculator drafts inside the feature while all migrated reports share one source choice.
export const calculatorsUseMockDataAtom = pbiMockDataEnabledAtom;

export const calculatorsStateAtom = atom<CalculatorsState>({
  request: initialCalculatorsRequest,
  response: null,
  isCalculating: false,
  error: null,
});
